import "./intro.scss"
import {init} from "ityped"
import { useEffect,useRef } from "react"

export default function Intro() {
    const textRef=useRef()
   useEffect(() => {
    init(textRef.current, { 
         backDelay:1500,
         backSpeed:60,
         showCursor:true,
         strings: ["Mathematician",'Developer', 'Designer',
         "System Analyst","Database Administrator" ] })
   }, [])
    return (
        <div className="intro" id="intro">
            <div className="left">
                <div className="imageContainer">
                    <img src="assets/mani.jpg" alt=""/>
                </div>
            </div>
            <div className="right">
                <div className="wrapper">
                    <h2>Hi There, I'm</h2>
                    <h1>Benzora Mustapha</h1>
                    <h3>Freelance <span ref={textRef}></span></h3>
                </div>
                <a href="#portfolio">
                    <img src="assets/button.png" alt=""/>
                </a>
            </div>
        </div>
    )
}
